import axios from "../axios-auth";
import orginal_axios from "axios";

export const accountReceivableReportService = {
    getAccountReceivableReport,
    printAccountReceivableReport,
    exportAccountReceivableReportExcel
};

function getAccountReceivableReport(searchParams, page, size) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }

    let params = {
        page: page,
        size: size
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    return axios.get("/auth/account-receivable-report", { params });
}

function printAccountReceivableReport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }

    return axios.get("/auth/account-receivable-report-print", { params });
}

function exportAccountReceivableReportExcel(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/account-receivable-report-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    })
}